import {useUserSettingsStore} from '@/store/user-settings.store.js'
import {storeToRefs} from 'pinia'

/**
 * User settings composable (convenience wrapper around the store)
 */
export function useUserSettings() {

  //Composables
  const store = useUserSettingsStore()
  const refs = storeToRefs(store)

  //Expose reactive interface
  return {
    ...store,
    ...refs,
  }
}
